import styled from 'styled-components'

const SocialsContainer = styled.div`
    display: flex;
    justify-content: center;
`

const SocialItem = styled.a`
    display: inline-block;
    text-align: center;
    transition: .2s;
    width: 60px;
    height: 60px;
    line-height: 55px;
    svg {
        width: 20px!important;
        height: 20px!important;
        color: #e65966;
    }
`

const LanguageContainer = styled.div`
    text-align: center;
`

const SupportLink = styled.div`
    display: block;
    text-align: center;
    margin-top: 10px;
    cursor: pointer;
    color: var(--pink)
`

export {
    SocialsContainer,
    SocialItem,
    LanguageContainer,
    SupportLink
}